import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { all, put, call, select, takeEvery } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { withOffset, selectors } from '../../Stream';
import { initializeUserStream } from './actions';
import { streamType } from './constants';
import { isApiError, requestPuppy } from '@wix/da-http-client/pkg/request';
import { FetchType } from '../../Stream/base/types';
const logger = ddt.createLogger('userlist');
function* doFetchUsers(deviationid, type, offset = 0, limit = 24) {
    const params = {
        deviationid,
        type,
        offset,
        limit
    };
    const result = yield call(requestPuppy, {
        method: 'get',
        url: 'who',
        params
    }, ()=>{
        if (process.env.NODE_ENV !== 'production') {
            const users = require('@wix/da-sample-data').users; // eslint-disable-line global-require
            const fetchableUsers = [
                ...users,
                ...users.map((user)=>_object_spread_props(_object_spread({}, user), {
                        userId: user.userId + 100000000
                    })),
                ...users.map((user)=>_object_spread_props(_object_spread({}, user), {
                        userId: user.userId + 200000000
                    }))
            ]; // lots of data to test loading
            return {
                hasMore: fetchableUsers.length > offset + limit,
                nextOffset: Math.min(offset + limit, fetchableUsers.length),
                total: fetchableUsers.length,
                results: fetchableUsers
            };
        }
        return {
            hasMore: false,
            results: [],
            total: 0
        };
    }, 'dadeviation');
    return result;
}
function* handleFetchUsers({ streamId }) {
    const { offset, limit, streamParams } = yield select((state)=>({
            streamParams: selectors.getStreamParams(state, streamId),
            offset: withOffset.selectors.getNextOffset(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId)
        }));
    if (!streamParams || streamParams.type !== streamType) {
        return;
    }
    const result = yield call(doFetchUsers, streamParams.deviationId, streamParams.streamType, offset, limit);
    if (!result || isApiError(result)) {
        yield put(withOffset.actions.fetchFailure({
            streamId,
            fetchType: FetchType.Next,
            errorMsg: 'Failed to fetch'
        }));
        return;
    }
    const { total, results: items, hasMore = false, nextOffset } = result;
    yield put(withOffset.actions.fetchSuccessDeduped({
        streamId,
        items,
        total,
        hasMore,
        nextOffset: nextOffset || undefined
    }));
}
function* handleInitialize({ payload: { deviationId, streamId, type } }) {
    const isInitialized = yield select(selectors.isInitialized, streamId);
    if (isInitialized) {
        return;
    }
    logger.log('Initializing user stream', deviationId, type);
    const streamParams = {
        type: streamType,
        deviationId,
        streamType: type
    };
    yield put(withOffset.actions.initialize({
        streamId,
        itemsPerFetch: 24,
        items: [],
        hasMore: true,
        streamParams
    }));
    yield put(withOffset.actions.fetch(streamId));
}
export default function* userRootSaga() {
    yield all([
        takeEvery(initializeUserStream, handleInitialize),
        takeEvery(withOffset.actions.STREAM__WITH_OFFSET__FETCH, handleFetchUsers)
    ]);
}

//# sourceMappingURL=saga.js.map